export const LOCALE_COOKIE_NAME = "NEXT_LOCALE";
export const DEFAULT_ROOT_LOCALE = "default";

export const REFERRAL_COOKIE_NAME = "referral_code";
export const REFERRAL_PARAM_NAME = "ref";

export const LEGAL_AGE = 18;

export enum FeedScopeEnum {
    "live" = "live",
    "prematch" = "prematch",
    "results" = "results",
}
